import { Helmet } from "react-helmet-async";
import FareImages from "../components/FareImages";
import { Accordion, AccordionBody, AccordionHeader, AccordionItem, Button, Card, CardBody, Col, Container, Modal, ModalBody, ModalHeader, Row } from "reactstrap";
import { useState } from "react";
import { Languages, MapPin, Phone, PhoneCall } from "lucide-react";
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import "./CarDetails.css";
function CarDetailsPage() {
  const currentUrl = window.location.href;
  const [offerPrice, setOfferPrice] = useState<number | null>(null);
  const [selectedImage, setSelectedImage] = useState(0);
  const [bookModal, setBookModal] = useState(false);
  const driverPhoneNumber = 7449215705;
  const [openFaq, setOpenFaq] = useState("1");

  const toggleFaq = (id: string) => {
    setOpenFaq(openFaq === id ? "" : id);
  };
  const images = [
    {
      src: "/assets/car/Front_view.webp",
      alt: "Front View",
    },
    {
      src: "/assets/car/Side_view_1.webp",
      alt: "Side View",
    },
    {
      src: "/assets/car/Car_first.webp",
      alt: "Ertiga"
    },
    {
      src: "/assets/car/Driver_seat.webp",
      alt: "Ertiga"
    },
    {
      src: "/assets/car/Car_Center_1.webp",
      alt: "Ertiga"
    },
    {
      src: "/assets/car/Car_last.webp",
      alt: "Ertiga"
    },
  ];


  const handleUnlockOffer = () => {
    const savedOffer = localStorage.getItem("specialOffer");
    const expiry = localStorage.getItem("specialOfferExpiry");

    const now = Date.now();

    if (savedOffer && expiry && now < Number(expiry)) {
      try {
        const decoded = JSON.parse(atob(savedOffer));

        setOfferPrice(decoded.v);

        return;
      } catch {
        localStorage.removeItem("specialOffer");
        localStorage.removeItem("specialOfferExpiry");
      }
    }

    const randomOffer =
      Math.floor(Math.random() * (200 - 20 + 1)) + 20;

    const expiryTime =
      now + 20 * 60 * 60 * 1000;

    const encoded = btoa(
      JSON.stringify({
        v: randomOffer,
        t: now
      })
    );

    localStorage.setItem("specialOffer", encoded);
    localStorage.setItem(
      "specialOfferExpiry",
      expiryTime.toString()
    );

    setOfferPrice(randomOffer);
  };
  return (
    <>
      <Helmet>
        <title>
          Maruti Suzuki Ertiga 6+1 Seater Taxi Rental in Bangalore | Best Price
        </title>

        <meta
          name="description"
          content="Book Maruti Suzuki Ertiga 6+1 seater AC taxi with an experienced driver in Bangalore. Affordable rates for local trips, airport pickup & drop, and outstation travel."
        />

        <meta
          name="keywords"
          content="Maruti Ertiga rental, Ertiga taxi booking, Ertiga car rental, 6+1 seater taxi, AC cab Bangalore, airport taxi Bangalore, outstation taxi, car rental with driver, Bangalore taxi service, HSR Layout taxi, Electronic City taxi, affordable taxi, Tamil driver Bangalore"
        />

        <meta
          property="og:title"
          content="Maruti Suzuki Ertiga 6+1 Seater Taxi Rental"
        />

        <meta
          property="og:description"
          content="Affordable Maruti Suzuki Ertiga taxi rental with experienced driver. Available for local, airport and outstation trips."
        />

        <meta property="og:type" content="website" />
        <meta property="og:url" content={currentUrl} />
        <meta name="robots" content="index,follow" />

        <meta property="og:site_name" content="PriceWorth" />

        <meta property="og:locale" content="en_IN" />

        <meta
          name="twitter:card"
          content="summary_large_image"
        />

        <meta
          name="twitter:title"
          content="Maruti Suzuki Ertiga Taxi Rental"
        />

        <meta
          name="twitter:description"
          content="Book Ertiga with experienced driver."
        />

        <meta
          name="twitter:image"
          content="https://priceworth.com/assets/car/Front_view.webp"
        />
        {/* Replace with your actual image URL */}
        <meta
          property="og:image"
          content="https://priceworth.com/assets/car/Front_view.webp"
        />
        <meta property="og:image:type" content="image/webp" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta
          property="og:image:alt"
          content="Maruti Suzuki Ertiga 6+1 Seater Taxi Rental"
        />

        <link rel="canonical" href={currentUrl} />

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "TaxiService",
            name: "Maruti Suzuki Ertiga Taxi Rental",
            telephone: "+91 7449215705",
            url: currentUrl,
            areaServed: "Bangalore",
            description:
              "Maruti Suzuki Ertiga 6+1 seater taxi rental with experienced driver for local, airport and outstation travel.",
            vehicle: {
              "@type": "Car",
              brand: "Maruti Suzuki",
              model: "Ertiga",
              seatingCapacity: 7
            }
          })}
        </script>
      </Helmet>


      <Container fluid className="mt-2 px-2 px-md-4">
        <div className="mb-4 p-4 bg-white rounded-4 shadow-sm border">
          <div className="text-center">
            <h2 className="fw-bold mb-3"
              style={{ fontSize: "clamp(1.2rem,3vw,2rem", lineHeight: '1.5' }}
            >
              Rent - Maruti Suziki Ertiga <span>6+1 Seater</span> <span>CNG + Petrol AC</span>
            </h2>

            <div className="text-muted" style={{ fontSize: "1.05rem", lineHeight: "1.8" }}>
              <p className="mb-2">  Hire Well maintained Air Conditioned 7 seater car with <strong>15+</strong> years experienced driver.</p>

              <p className="mb-3">Find below fair details including driver charges and excluding toll and parking charges.</p>

              <Col xs="12" className="text-center mb-4">
                <Button
                  color="primary"
                  className="rounded px-4 shadow blink-btn"
                  onClick={handleUnlockOffer}
                >
                  🔓 Unlock Today's Special Offer
                </Button>
              </Col>
              {offerPrice && (
                <div className="text-center mt-3 p-3 rounded shadow" style={{ background: "linear-gradient(135deg,#0d6efd,#0b5ed7)", color: "#fff" }} >
                  <h5 className="mb-1"> 🎉 Special Offer Unlocked! </h5> <h2 className="fw-bold mb-0"> ₹{offerPrice} </h2>
                  <small style={{ fontSize: '13px' }}> This offer is locked for you for the next 24 hours. </small>
                </div>

              )}
           <div className="pricing-wrapper">

  <div className="pricing-header">
    <h3>🚕 Rental Package</h3>
    <p>Choose the package that suits your journey</p>
  </div>

  <div className="table-responsive">
    <table className="pricing-table">

      <thead>
        <tr>
          <th>Package</th>
          <th>Distance</th>
          <th>Price</th>
        </tr>
      </thead>

      <tbody>
        <tr>
          <td>
            <strong>8 Hours</strong>
          </td>
          <td>80 KM</td>
          <td>
            <span className="price">₹4,000</span>
          </td>
        </tr>

        <tr>
          <td>
            <strong>12 Hours</strong>
          </td>
          <td>120 KM</td>
          <td>
            <span className="price">₹4,800</span>
          </td>
        </tr>

        <tr>
          <td>
            <strong>16 Hours</strong>
          </td>
          <td>160 KM</td>
          <td>
            <span className="price">₹5,600</span>
          </td>
        </tr>
      </tbody>

    </table>
  </div>
  <div><strong>Toll and parking charges are not included.</strong></div>


  <div className="extra-charges">

    <div className="extra-charge">
      <span className="charge-icon">⏱️</span>

      <div>
         <h5 style={{fontWeight:"bolder"}}>Extra Hours</h5>
        <strong>₹100 per extra hour</strong>
      </div>
    </div>


    <div className="extra-charge">
      <span className="charge-icon">📍</span>

      <div>
        <h5 style={{fontWeight:"bolder"}}>Extra KM</h5>
        <strong>₹10 per extra KM</strong>
      </div>
    </div>

  </div>

</div>
             <div className="booking-contact-card">

  <div className="booking-header">
    <div className="booking-icon">
      📞
    </div>

    <div>
      <h5>For Booking Call</h5>
      <p>Contact us for booking & enquiries</p>
    </div>
  </div>


  <div className="phone-list">

    {[
      "8056355636",
      "8489611297",
      "8884125353",
      "6379128559",
    ].map((phone) => (

      <a
        key={phone}
        href={`tel:${phone}`}
        className="phone-card"
      >

        <div className="phone-icon">
          📞
        </div>

        <div className="phone-details">
          <span>Call Now</span>
          <strong>{phone}</strong>
        </div>

        <div className="call-arrow">
          →
        </div>

      </a>

    ))}

  </div>

</div>
            </div>

          </div>

          <Card className="shadow-sm border-0 rounded-4 mt-4">
            <CardBody>
              <h4 className="fw-bold mb-4 text-center">

              </h4>

              <Row>
                <Col md="6" className="mb-4">
                  <div className="pricing-box">
                    <h2 className="pricing-title">
                      Distance Based Charges
                    </h2>

                    <table className="table table-bordered align-middle text-center mb-0">
                      <thead className="table-light">
                        <tr>
                          <th>Distance</th>
                          <th>Rate</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>Up to 50 KM</td>
                          <td>₹1000</td>
                        </tr>
                        <tr>
                          <td>51 to 100 KM</td>
                          <td>₹20 / KM</td>
                        </tr>
                        <tr>
                          <td>101 - 200 KM</td>
                          <td>₹18 / KM</td>
                        </tr>
                        <tr>
                          <td>Above 200 KM</td>
                          <td>₹15 / KM</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </Col>

                <Col md="6" className="mb-4">
                  <div className="pricing-box">
                    <h2 className="pricing-title">
                      Hourly Rental Charges
                    </h2>

                    <table className="table table-bordered align-middle text-center mb-0">
                      <thead className="table-light">
                        <tr>
                          <th>Duration</th>
                          <th>Rate</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>Up to 8 Hours</td>
                          <td>₹200 / Hour</td>
                        </tr>
                        <tr>
                          <td>8 - 16 Hours</td>
                          <td>₹150 / Hour</td>
                        </tr>
                        <tr>
                          <td>16 - 24 Hours</td>
                          <td>₹100 / Hour</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </Col>
              </Row>
              <div className="mt-4 p-3 bg-light rounded-3">
                <h6 className="fw-bold mb-2">
                  Important Notes
                </h6>

                <ul className="mb-0">
                  <li>
                    Driver charges included.
                  </li>
                  <li>
                    Toll, parking and interstate taxes are extra.
                  </li>

                  <li>
                    Minimum billing may apply for local trips.
                  </li>
                </ul>
              </div>
            </CardBody>
          </Card>
        </div>


        <Card className="shadow-sm border-0 mb-4 rounded-4">
          <CardBody>
            <Row>
              <Col md="12">
                <h3 className="text-center mb-4">Real Photos</h3>

                {/* Main Image */}
                <div
                  className="border rounded-4 overflow-hidden shadow-sm bg-white"
                  style={{
                    aspectRatio: "4 / 3",
                    width: "100%",
                    maxWidth: "700px",
                    margin: "0 auto",
                  }}
                >
                  <img
                    src={images[selectedImage].src}
                    alt={images[selectedImage].alt}
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "contain",
                    }}
                  />
                </div>

                {/* Thumbnails */}
                <Row className="mt-3 g-2 justify-content-center">
                  {images.map((img, index) => (
                    <Col xs="3" sm="2" md="2" key={index}>
                      <div
                        className={`border rounded-3 overflow-hidden ${selectedImage === index
                          ? "border-primary border-3"
                          : ""
                          }`}
                        style={{
                          aspectRatio: "3 / 2",
                          cursor: "pointer",
                        }}
                        onClick={() => setSelectedImage(index)}
                      >
                        <img
                          src={img.src}
                          alt={img.alt}
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                          }}
                        />
                      </div>
                    </Col>
                  ))}
                </Row>
              </Col>
            </Row>

            <Card className="mt-4">
              <CardBody>
                <h5 className="mb-3">Vehicle Description</h5>

                <p>
                  Our Maruti Suzuki Ertiga is a clean, well-maintained 6+1 seater AC vehicle
                  ideal for family trips, airport transfers, business travel, weddings,
                  and outstation tours.
                </p>

                <ul>
                  <li>Petrol + CNG</li>
                  <li>Air Conditioned</li>
                  <li>Comfortable Push Back Seats</li>
                  <li>Large Boot Space</li>
                  <li>Experienced Driver</li>
                  <li>Available 24×7</li>
                </ul>
              </CardBody>
            </Card>
          </CardBody>
        </Card>

        {/* ---driver details--- */}


        <Card className="shadow-sm border-0 mb-4 rounded-4">
          <CardBody>
            <h3 className="text-center fw-bold mb-4">
              Driver Information
            </h3>

            <Row className="g-4">
              {/* Driver Profile */}
              <Col xs="12" lg="3" className="text-center">
                <img
                  src="/assets/car/Driver_Velu_Image.webp"
                  alt="Driver Velu"
                  className="rounded-circle shadow border"
                  style={{
                    width: "180px",
                    height: "180px",
                    objectFit: "cover",
                    maxWidth: "100%",
                  }}
                />

                <h4 className="mt-3 mb-1 fw-bold">
                  Velu
                </h4>

                <span className="badge bg-success px-3 py-2">
                  15+ Years Experience
                </span>
              </Col>

              {/* Driver Details */}
              <Col xs="12" lg="9">
                <Row className="g-3">
                  {/* Driving Licence */}
                  <Col xs="12" md="6">
                    <div className="border rounded-4 p-3 h-100 bg-light text-center">
                      <h5 className="fw-bold mb-3">
                        Driving Licence
                      </h5>

                      <img
                        src="/assets/car/HDL_Front_Driver-Velu.webp"
                        alt="Driving Licence"
                        className="img-fluid rounded shadow"
                        style={{
                          maxHeight: "220px",
                          objectFit: "contain",
                        }}
                      />
                    </div>
                  </Col>

                  {/* Languages */}
                  <Col xs="12" md="6">
                    <div className="border rounded-4 p-3 h-100 bg-light">
                      <div className="d-flex align-items-center mb-3">
                        <Languages
                          size={22}
                          className="me-2 text-primary"
                        />

                        <h5 className="fw-bold mb-0">
                          Languages Spoken
                        </h5>
                      </div>

                      <div className="d-flex flex-wrap gap-2">
                        <span className="badge bg-primary">
                          Tamil
                        </span>

                        <span className="badge bg-success">
                          English
                        </span>

                        <span className="badge bg-warning text-dark">
                          Kannada
                        </span>

                        <span className="badge bg-danger">
                          Hindi
                        </span>
                      </div>
                      <hr />
                      <div className="d-flex align-items-center mt-3 mb-3">
                        <MapPin
                          size={22}
                          className="me-2 text-danger"
                        />

                        <h5 className="fw-bold mb-0">
                          Driver Location
                        </h5>
                      </div>

                      <p className="mb-0">
                        HSR Layout, Bangalore
                      </p>
                    </div>
                  </Col>

                  {/* Experience */}
                  <Col xs="12" md="6">
                    <div className="border rounded-4 p-3 h-100 bg-light">
                      <h5 className="fw-bold mb-3">
                        Driving Experience
                      </h5>

                      <ul className="mb-0 ps-3">
                        <li>15+ Years of Professional Driving</li>
                        <li>Safe & Defensive Driving</li>
                        <li>Clean Driving Record</li>
                        <li>Polite & Friendly Behaviour</li>
                        <li>Experienced in Local & Outstation Trips</li>
                      </ul>
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row>
          </CardBody>
        </Card>

        {/* --- Contact Flaot --- */}

        <Button
          color="primary"
          size="lg"
          className="rounded-pill shadow px-4"
          style={{
            position: "fixed",
            bottom: "20px",
            left: "20px",
            zIndex: 9999,
            background: "linear-gradient(135deg, #0d6efd, #0b5ed7)",
            border: "none"
          }}
          onClick={() => setBookModal(true)}
        >
          <Phone size={18} className="me-2" />
          Book Ertiga
        </Button>

        <a
          href={`tel:${driverPhoneNumber}`}
          style={{
            position: "fixed",
            bottom: "20px",
            right: "20px",
            zIndex: 9999,
            textDecoration: "none"
          }}
        >
          <Button
            color="success"
            size="lg"
            className="rounded-pill shadow"
          >
            <Phone size={18} className="me-2" />
            Call Driver
          </Button>
        </a>

        <a
          href={`https://wa.me/91${driverPhoneNumber}`}
          target="_blank"
          rel="noopener noreferrer"
          style={{
            position: "fixed",
            bottom: "90px",
            right: "20px",
            zIndex: 9999,
          }}
        >
          <Button
            color="success"
            className="rounded-pill shadow"
          >
            <WhatsAppIcon />
          </Button>
        </a>


        <Modal
          isOpen={bookModal}
          toggle={() => setBookModal(false)}
          centered
        >
          <ModalHeader
            toggle={() => setBookModal(false)}
            className="text-white"
            style={{
              background: "linear-gradient(135deg, #0d6efd, #0b5ed7)"
            }}
          >
            <PhoneCall size={20} className="me-2" />
            For Booking Contact
          </ModalHeader>

          <ModalBody className="p-4">

            {/* <p className="text-center text-muted mb-4">
                            For booking call 
                        </p> */}

            {[
              {
                name: "8056355636",
                phone: "8056355636"
              },
              {
                name: "8489611297",
                phone: "8489611297"
              },
              {
                name: "8884125353",
                phone: "8884125353"
              },
              {
                name: "6379128559",
                phone: "6379128559"
              }
            ].map((item, index) => (
              <div
                key={index}
                className="border rounded-4 p-3 mb-3 shadow-sm"
                style={{
                  backgroundColor: "#f8fbff"
                }}
              >
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <h6
                      className="mb-1 fw-bold"
                      style={{ color: "#0d6efd", fontSize: '18px' }}
                    >
                      {item.name}
                    </h6>

                    {/* <small className="text-muted">
                                            {item.phone}
                                        </small> */}
                  </div>


                  <div>
                    <a
                      href={`tel:${item.phone}`}
                      style={{ textDecoration: "none" }}
                      className="me-2"
                    >
                      <Button
                        color="primary"
                        className="rounded-pill px-3"
                      >
                        <Phone size={16} className="me-1" />
                        Call
                      </Button>
                    </a>
                    <a
                      href={`https://wa.me/91${item.phone}?text=${encodeURIComponent(
                        "Hi, I would like to book the Maruti Suzuki Ertiga."
                      )}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ textDecoration: "none" }}
                    >
                      <Button
                        color="success"
                        className="rounded-pill px-3"
                      >
                        <WhatsAppIcon />

                      </Button>
                    </a>

                  </div>


                </div>
              </div>
            ))}

            <div
              className="text-center mt-3 p-3 rounded-3"
              style={{
                background: "#e7f1ff",
                color: "#0d6efd"
              }}
            >
              <strong>WhatsApp 24×7</strong><br />
              <strong>Call 6am to 11pm</strong>
              <br />
              {/* Quick support for bookings and trip enquiries. */}
            </div>
          </ModalBody>
        </Modal>


        {/* ---FAQ--- */}

        <Card className="mt-4 shadow-sm border-0 rounded-4 mb-5">
          <CardBody className="mb-5">
            <div className="text-center mb-">
              <h3 className="fw-bold">
                ❓ Frequently Asked Questions
              </h3>
              <p className="text-muted mb-0">
                Everything you need to know before booking.
              </p>
            </div>

            <Accordion open={openFaq} toggle={toggleFaq}>
              <AccordionItem>
                <AccordionHeader targetId="1">
                  Is driver charge included?
                </AccordionHeader>

                <AccordionBody accordionId="1">
                  ✅ Yes. Driver charges are already included in the rental fare.
                </AccordionBody>
              </AccordionItem>

              <AccordionItem>
                <AccordionHeader targetId="2">
                  Is fuel included?
                </AccordionHeader>

                <AccordionBody accordionId="2">
                  ✅ Yes. Fuel charges are included in the rental amount.
                </AccordionBody>
              </AccordionItem>

              <AccordionItem>
                <AccordionHeader targetId="3">
                  Are toll and parking charges included?
                </AccordionHeader>

                <AccordionBody accordionId="3">
                  ❌ No. Toll charges, parking fees and interstate taxes (if any)
                  are charged separately.
                </AccordionBody>
              </AccordionItem>

              <AccordionItem>
                <AccordionHeader targetId="4">
                  Is airport pickup & drop available?
                </AccordionHeader>

                <AccordionBody accordionId="4">
                  ✅ Yes. We provide 24×7 airport pickup and drop services in
                  Bangalore.
                </AccordionBody>
              </AccordionItem>

              <AccordionItem>
                <AccordionHeader targetId="5">
                  Do you provide outstation trips?
                </AccordionHeader>

                <AccordionBody accordionId="5">
                  ✅ Yes. We provide both local and outstation taxi services across
                  Karnataka and nearby states.
                </AccordionBody>
              </AccordionItem>

              <AccordionItem>
                <AccordionHeader targetId="6">
                  How can I book the taxi?
                </AccordionHeader>

                <AccordionBody accordionId="6">
                  📞 You can call us directly or book instantly through WhatsApp
                  using the buttons available on this page.
                </AccordionBody>
              </AccordionItem>

              <AccordionItem>
                <AccordionHeader targetId="7">
                  What type of vehicle is provided?
                </AccordionHeader>

                <AccordionBody accordionId="7">
                  🚗 A well-maintained Maruti Suzuki Ertiga 6+1 Seater AC (Petrol +
                  CNG) with an experienced driver.
                </AccordionBody>
              </AccordionItem>
            </Accordion>
          </CardBody>
        </Card>
      </Container>


    </>
  );
}

export default CarDetailsPage;